import { render, staticRenderFns } from "./LineItemDeleteForm.vue?vue&type=template&id=df1fb854&"
import script from "./LineItemDeleteForm.js?vue&type=script&lang=js&"
export * from "./LineItemDeleteForm.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./LineItemDeleteForm.txt?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fcartdetail%2FLineItemDeleteForm%2FLineItemDeleteForm.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports